// removed by extract-text-webpack-plugin
module.exports = {"colorWhite":"#ffffff","draggableEditorItem":"draggable-item__draggableEditorItem____2z8v8"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/drag-and-drop/draggable-item.css
// module id = 612
// module chunks = 0